export default __webpack_public_path__ + "static/media/visa_logo_icon.fabeb54f.svg";